import {Route, Routes, Outlet, Navigate} from 'react-router-dom'
import {PageLink, PageTitle} from '../../../_dashboard/layout/core'
import { ContactListWrapper } from './ContactComponent'
import { useIntl } from 'react-intl'

const ContactPage = () => {
  const intl = useIntl()

  const ContactBreadcrumbs: Array<PageLink> = [
    {
      title: intl.formatMessage({ id: 'CONTACT_PAGE.BREADCRUMB' }),
      path: '/apps/Contact-management/Contact',
      isSeparator: false,
      isActive: false,
    },
    {
      title: '',
      path: '',
      isSeparator: true,
      isActive: false,
    },
  ]

  return (
    <Routes>
      <Route element={<Outlet />}>
        <Route
          path='Contact'
          element={
            <>
              <PageTitle breadcrumbs={ContactBreadcrumbs}>
                {intl.formatMessage({ id: 'CONTACT_PAGE.TITLE' })}
              </PageTitle>
              <ContactListWrapper/>
            </>
          }
        />
      </Route>
      <Route index element={<Navigate to='/apps/Contact-management/Contact' />} />
    </Routes>
  )
}

export default ContactPage
